"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,12.94V7.89A5.69,5.69,0,0,0,18.32,2.2H5.68A5.69,5.69,0,0,0,0,7.89v5.05a5.69,5.69,0,0,0,5.68,5.68h.63V23a.63.63,0,0,0,1.08.45l4.87-4.87h6.05A5.69,5.69,0,0,0,24,12.94Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;